import React from "react";
import {Button, Card, Stack, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {pageAuthorizedByGroup} from "../fragments/PageAuthorization";
import {Calculate} from "@mui/icons-material";
import {translateFunction} from "../../localization/TranslationService";

const translate = translateFunction("SureBasePortalMonitoring");

export const MonitoringOverviewPage = pageAuthorizedByGroup(function () {
	return <>
		<Stack direction={"row"} justifyContent={"space-evenly"} style={{width: "100%"}}>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<Calculate fontSize={"large"}/>
						<Typography>{translate("Comparisons")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./comparisons"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
		</Stack>
	</>;
}, ["Admin", "Monitoring"]);
